import { makeDataErrorMessages } from '@atlassian/amkt-common';
import { getFrontendBootstrap } from '@atlassian/mpac-api-client';
import { getFeatureFlagsClient, MarketplaceType } from '@atlassian/mpac-feature-flags';
import { log } from '@atlassian/mpac-utils';
import { Option } from 'funfix-core';
import AnalyticsClient from '../../analytics/Client';
import { appConfig } from '../../constants/Configuration';
import { EmceeVariant } from '../../constants/EmceeVariants';
import { makeHostInfo } from '../../records/HostInfo';
import { getCloudIdFromHostInfo } from '../../services/HostInfoApi';
import getSPI from '../../services/SPI';
import { isEmceeConnect } from '../../utils/package-connect-utils';
export const FETCH_HOST_INFO = 'CONFIGURATION_FETCH_HOST_INFO';
export const RECEIVE_HOST_INFO = 'CONFIGURATION_RECEIVE_HOST_INFO';
export const RECEIVE_HOST_INFO_ERROR = 'CONFIGURATION_RECEIVE_HOST_INFO_ERROR';
export const FETCH_HOST_CONFIG = 'CONFIGURATION_FETCH_HOST_CONFIG';
export const RECEIVE_HOST_CONFIG = 'CONFIGURATION_RECEIVE_HOST_CONFIG';
export const RECEIVE_HOST_CONFIG_ERROR = 'CONFIGURATION_RECEIVE_HOST_CONFIG_ERROR';
export const RECEIVE_FEATURE_FLAGS = 'CONFIGURATION_RECEIVE_FEATURE_FLAGS';
export const RECEIVE_FEATURE_FLAGS_ERROR = 'CONFIGURATION_RECEIVE_FEATURE_FLAGS_ERROR';
export const FETCH_FRONTEND_BOOTSTRAP_CONFIG = 'CONFIGURATION_FETCH_FRONTEND_BOOTSTRAP';
export const RECEIVE_FRONTEND_BOOTSTRAP_CONFIG = 'CONFIGURATION_RECEIVE_FRONTEND_BOOTSTRAP';
const fetchHostInfo = () => ({
  type: FETCH_HOST_INFO
});
const receiveHostInfo = _ref => {
  let {
    hostInfo
  } = _ref;
  return {
    type: RECEIVE_HOST_INFO,
    hostInfo
  };
};
const receiveHostInfoError = _ref2 => {
  let {
    dataErrorMessages
  } = _ref2;
  return {
    type: RECEIVE_HOST_INFO_ERROR,
    dataErrorMessages
  };
};
const fetchHostConfig = () => ({
  type: FETCH_HOST_CONFIG
});
const fetchFrontendBootstrap = () => ({
  type: FETCH_FRONTEND_BOOTSTRAP_CONFIG
});
const receiveFrontendBootstrap = _ref3 => {
  let {
    frontendBootstrap
  } = _ref3;
  return {
    type: RECEIVE_FRONTEND_BOOTSTRAP_CONFIG,
    frontendBootstrap
  };
};
const receiveHostConfig = _ref4 => {
  let {
    hostConfig
  } = _ref4;
  return {
    type: RECEIVE_HOST_CONFIG,
    hostConfig
  };
};
const receiveHostConfigError = _ref5 => {
  let {
    dataErrorMessages
  } = _ref5;
  return {
    type: RECEIVE_HOST_CONFIG_ERROR,
    dataErrorMessages
  };
};
export const receiveFeatureFlags = _ref6 => {
  let {
    featureFlags
  } = _ref6;
  return {
    type: RECEIVE_FEATURE_FLAGS,
    featureFlags
  };
};
const receiveFeatureFlagsError = _ref7 => {
  let {
    dataErrorMessages
  } = _ref7;
  return {
    type: RECEIVE_FEATURE_FLAGS_ERROR,
    dataErrorMessages
  };
};
export const doRetrieveFeatureFlags = _ref8 => {
  let {
    bootstrapConfig,
    hostInfo,
    currentUserId
  } = _ref8;
  return async dispatch => {
    try {
      const customAttributes = {
        emceeVariant: isEmceeConnect() ? EmceeVariant.Connect : EmceeVariant.Native,
        emceeHostProduct: hostInfo.product,
        marketplaceType: MarketplaceType.EMCEE
      };
      const featureFlagClient = await getFeatureFlagsClient({
        apiKey: bootstrapConfig.featureFlags.apiKey,
        environment: bootstrapConfig.featureFlags.environment,
        userId: currentUserId,
        additionalIds: {
          tenantId: getCloudIdFromHostInfo(hostInfo)
        },
        analyticsClient: AnalyticsClient.get(),
        productKey: hostInfo.product,
        customAttributes
      });
      dispatch(receiveFeatureFlags({
        featureFlags: featureFlagClient
      }));
      return featureFlagClient;
    } catch (error) {
      dispatch(receiveFeatureFlagsError({
        dataErrorMessages: makeDataErrorMessages([error])
      }));
      throw error;
    }
  };
};
export const doRetrieveHostInfo = () => dispatch => new Promise((resolve, reject) => {
  dispatch(fetchHostInfo());
  getSPI().getHostInfo().then(hostInformation => {
    const hostInfo = makeHostInfo(hostInformation);
    dispatch(receiveHostInfo({
      hostInfo
    }));
    resolve(hostInfo);
  }, error => {
    log.error('Configuration', "failed to retrieve HostInfo : ".concat(error));
    dispatch(receiveHostInfoError({
      dataErrorMessages: makeDataErrorMessages([error])
    }));
    reject(error);
  });
});
const resolveHostConfig = hostInfo => Promise.resolve(Option.of(appConfig.get(hostInfo.product)).getOrElseL(() => Promise.reject("No configuration present for this product '".concat(hostInfo.product, "'"))));
export const doRetrieveHostConfig = hostInfo => dispatch => new Promise((resolve, reject) => {
  dispatch(fetchHostConfig());
  resolveHostConfig(hostInfo).then(hostConfig => {
    dispatch(receiveHostConfig({
      hostConfig
    }));
    resolve(hostConfig);
  }, error => {
    log.error('Configuration', "failed to retrieve HostConfig : ".concat(error));
    dispatch(receiveHostConfigError({
      dataErrorMessages: makeDataErrorMessages([error])
    }));
    reject(error);
  });
});
export const doRetrieveFrontendBootstrap = () => dispatch => new Promise(resolve => {
  dispatch(fetchFrontendBootstrap());
  getFrontendBootstrap().then(frontendBootstrap => {
    dispatch(receiveFrontendBootstrap({
      frontendBootstrap
    }));
    resolve(frontendBootstrap);
  }, () => {
    /*
     * The code should never reach here
     * getFrontendBootstrap() catches any exceptions & resolves to a fallback value
     */
  });
});